import * as React from 'react';
export const grokSvg = React.forwardRef(function grokSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      style: {
        fill: 'light-dark(#000,#fff)',
      },
      d: 'm12.928 19.69 8.976-6.655c.44-.326 1.069-.2 1.279.308 1.103 2.672.61 5.884-1.586 8.089-2.195 2.205-5.25 2.688-8.043 1.587l-3.05 1.418c4.375 3.003 9.688 2.26 13.008-1.076 2.633-2.644 3.45-6.25 2.686-9.5l.007.007C25.1 9.092 26.477 7.183 29.3 3.28l.2-.28-3.714 3.73v-.012l-12.86 12.974m-1.851 1.615c-3.14-3.013-2.599-7.675.081-10.364 1.981-1.99 5.228-2.802 8.062-1.608l3.043-1.411a8.8 8.8 0 0 0-2.057-1.127A10.07 10.07 0 0 0 9.232 9.014c-2.85 2.862-3.746 7.262-2.207 11.018 1.15 2.806-.735 4.792-2.633 6.795-.673.71-1.348 1.421-1.892 2.173l8.573-7.691',
    }),
  );
});
grokSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var grok = {
  category: 'brand',
  colorable: false,
  name: 'grok',
  svg: grokSvg,
};
